export { default } from './useIsSsr'
